import withState from "../../../../../../../utils/withState";
import {tableFilters$} from "../../utils/tableFilters";
import IntervalFilterMerchant from "./components/IntervalFilterMerchant";
import React from "react";
import {tableScroll$} from "../../utils/tableScroll";
import {AutoSizer} from "react-virtualized";

export default withState((setState, self, onMount) => {

  self.state = {
    throttleTimeout: false
  }

  const onChange = (value = {}) => {
    if (self.state.throttleTimeout) {
      clearTimeout(self.state.throttleTimeout);
    }

    const nextFilters = {
      ...self.state.filters,
      ...value
    };

    tableFilters$.emit(nextFilters);

    const throttleTimeout = setTimeout(() => {
      const onFiltersChange = self.props.onFiltersChange;
      if (onFiltersChange) {
        onFiltersChange(nextFilters);
        tableScroll$.emit('');
      }
    }, 500);

    setState({
      throttleTimeout
    })
  }

  return (state, props) => {
    const filtersParams = props.filtersParams || {};
    const selects = filtersParams.selects || {};
    const selectFilters = Object.keys(selects).map((key) => selects[key]);

    return (
      <AutoSizer disableHeight>
        {({width}) => {
          return (
            <div style={{width: width}}>
              <IntervalFilterMerchant
                mobile={width <= props.columnsTotalWidth || width < 995}
                selectFilters={selectFilters}

                data={state.filters || props.defaultFiltersData}

                hideSearch={props.hideSearch}
                filtersParams={props.filtersParams}
                report={props.report}
                update={props.update}

                onChange={onChange}
              />
            </div>
          )
        }}
      </AutoSizer>
    )
  }
}, {
  filters: tableFilters$
})
